import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { HomeService } from "./home.service";
import { SessionStateService } from "../../core/services/session-state.service";
import { GeneralService } from "../../shared/services/general.service";
import { AuthenticationService } from "../../core/services/authentication.service";
import { HomeType } from "./home.constants";
import {
  HOUSE_SERVICE_PROVIDERS,
  HOUSE_STATUS,
} from "../houses/houses.constants";
import { DevicesService } from "../devices/devices.service";
import { GROUP, DeviceType } from "../devices/devices.constant";
import { Observable } from "rxjs";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit, OnDestroy {
  boxOn: boolean;
  loading: boolean;
  menu: String[] = [];
  hasType = false;
  isMobile;
  isWindowsPhone = false;
  houseWithoutDeviceInstalled: boolean;

  constructor(
    private homeService: HomeService,
    private authenticationService: AuthenticationService,
    private sessionStateService: SessionStateService,
    private devicesService: DevicesService,
    private generalService: GeneralService
  ) {}

  ngOnInit() {
    this.isMobile = this.generalService.isMobile();
    this.isWindowsPhone = this.generalService.isWindowsPhone();
    this.loading = true;

    this.generalService
      .getBoxConnectionStatus()
      .map((state) => {
        this.boxOn = state;
        this.initComponent();
      })
      .catch(() => {
        // If device was not installed yet, flows should be shown
        // In order to guarantee that the flows screen is correctly shown, device is setted to online
        if (this.deviceIsNotInstalledYet()) {
          this.menu = [HomeType.FLOWS_VIEW];
          this.boxOn = true;
          this.loading = false;
          return Observable.empty();
        }

        // Otherwise (some strange error)
        this.boxOn = false;
        this.initComponent();
        return Observable.empty();
      })
      // .finally(() => (this.loading = false))
      .subscribe();
    this.generalService.connChange.subscribe((state) => {
      this.boxOn = state;
      if (state) {
        this.initComponent();
      }
    });
  }

  initComponent() {
    this.houseWithPlugs()
      .finally(() => (this.loading = false))
      .catch((err) => {
        this.menu = [HomeType.FLOWS_VIEW];
        return Observable.empty();
      })
      .subscribe((houseWithPlugs) => {
        this.menu = Object.keys(HomeType).map((k) =>
          k.toLowerCase().replace("_", " ")
        );
      });
  }

  changeTab(event) {
    this.hasType = event;
  }

  getBoxConnectionStatus() {
    return this.boxOn;
  }

  ngOnDestroy() {
    this.generalService.initConnChange();
  }

  showCoachMark(type) {
    return this.sessionStateService.getCoachMarkIndividualState().get(type);
  }

  houseWithPlugs() {
    const houseId = this.sessionStateService.getHouse().houseId;
    return this.devicesService
      .getHouseModules(houseId, DeviceType.CONSUMPTION)
      .map((modules) => {
        return modules.length > 0;
      });
  }

  deviceIsNotInstalledYet(): boolean {
    const serviceProvider = this.sessionStateService.getHouse().serviceProvider;
    const houseStatus = this.sessionStateService.getHouse().status;

    // Condition to evaluate if installation was not made yet.
    // - House from Portugal
    // - House with status = notInitialized
    // - House without device
    if (
      serviceProvider === HOUSE_SERVICE_PROVIDERS.PORTUGAL &&
      houseStatus === HOUSE_STATUS.NOT_INITIALIZED
    ) {
      this.houseWithoutDeviceInstalled = true;
      return true;
    }
    this.houseWithoutDeviceInstalled = false;
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/home/home.component.ts